export enum LazoInvitationType {
  USER_TO_COMPANY = "USER_TO_COMPANY",
}
